/**
 * @module refreshActionEndpoint
 */

import actionEndpointStore from '../store/actionEndpointStore';
import { ActionEndpointRequestState } from '../store/schema/actionEndpointCache';
import loadActionEndpoint from '../actions/loadActionEndpoint';

/**
 * @function
 * To fetch the new action endpoint from the AutoD API
 */
const refreshActionEndpoint = (): void => {
    if (actionEndpointStore.requestState === ActionEndpointRequestState.InProgress) {
        return;
    }
    loadActionEndpoint();
};

export default refreshActionEndpoint;
